import apiClient from '../partner-payment-service.client'
import type { PartnerVcnWexShowPanResponseDto } from './dto/partner-vcn-wex-showpan.dto'

export type { PartnerVcnWexShowPanResponseDto } from './dto/partner-vcn-wex-showpan.dto'

/**
 * Partner Payment Service VCN WEX routes (base URL = `PARTNER_PAYMENT_SERVICE_URL`).
 */

/** `GET /vcn/wex/:vcn_card_id/showpan` */
export async function getPartnerVcnWexShowPan(
  vcnCardId: string
): Promise<PartnerVcnWexShowPanResponseDto> {
  const response = await apiClient.get<PartnerVcnWexShowPanResponseDto>(
    `vcn/wex/${encodeURIComponent(vcnCardId)}/showpan`
  )
  return response.data
}
